<template>
  <div class="search-bottom-menu-area">
    <div class="search-bottom-menu-item" @click.prevent="showCategory">
      <span class="icon">
      <category-search-icon />
      </span>
      <span class="text">
        카테고리 검색
      </span>
    </div>
    <div class="search-bottom-menu-item" @click.prevent="showTags">
      <span class="icon">
      <tag-search-icon />
      </span>
      <span class="text">
        태그 검색
      </span>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/components/eventbus/EventBus'
import CategorySearchIcon from '@/assets/svg/common/ic_search_category.svg'
import TagSearchIcon from '@/assets/svg/common/ic_search_tag.svg'

export default {
  name: 'SearchBottomMenu',
  components: {
    CategorySearchIcon,
    TagSearchIcon
  },
  methods: {
    showCategory () {
      this.$router.push('/search/category')
      // EventBus.$emit('show-category-search')
    },
    showTags () {
      EventBus.$emit('show-tag-search')
    }
  }
}
</script>

<style scoped>
.search-bottom-menu-area {
  position: relative;
  width: 100%;
  box-sizing: border-box;
}
.search-bottom-menu-item {
  width: 100%;
  padding: 16px 0;
  text-align: center;
  line-height: 0;
  box-sizing: border-box;
  color: #fff;
}
.search-bottom-menu-item .icon{
  display: inline-block;
  vertical-align: middle;
  width: 18px;
  height: 18px;
  margin-right: 8px;
}
.search-bottom-menu-item .text{
  display: inline-block;
  vertical-align: middle;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}
</style>
